import { selectLocation } from 'locations/actions/locations';

import {
  OPEN_NOTIFICATION_MODAL,
  CLOSE_NOTIFICATION_MODAL
} from 'base/actions/actionTypes';

export function openNotificationModal(notificationType, modalProps) {
  return {
    type: OPEN_NOTIFICATION_MODAL,
    payload: { notificationType, modalProps }
  };
}

export function closeNotificationModal() {
  return { type: CLOSE_NOTIFICATION_MODAL };
}

export const handleLocationSwitch = (
  onlineOrderingLocation,
  onlineOrderingFulfillmentMethod
) => async dispatch => {
  dispatch(closeNotificationModal());
  dispatch(
    selectLocation(onlineOrderingLocation, onlineOrderingFulfillmentMethod)
  );
};
